(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairPreApprovedController', PhysicalFairPreApprovedController)

    PhysicalFairPreApprovedController.$inject = ['$uibModal', 'SellerService' ,'ExpoService', 'PhysicalFairService'];


    function PhysicalFairPreApprovedController($uibModal, SellerService, ExpoService, PhysicalFairService) {
        var vm = this;


        vm.preApprovedList       = '';
        vm.queryFlag             = false;
        vm.exhibitorName         = '';
        vm.email                 = '';
        vm.expo                  = '';
        vm.expoSelected          = '';

        vm.seller                = '';
        vm.sellerSelected        = '';
        vm.active                = [{name:'All',value:'All'}, {name:'Yes', value:1}, {name:'No', value:0}];
        vm.activeSelected        = {name:'No', value:0};
        vm.selectExpo            = selectExpo;
        vm.getByFilter           = getByFilter;
        vm.getSellers            = getSellers;
        vm.openEditModal         = openEditModal;


        function activate() {
            vm.selectExpo();
            vm.getSellers();
            vm.getByFilter();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                    vm.expo = response.data;
            }).catch(function(err) {

            });
        }

        function getSellers() {
            SellerService.getAll().then(function(response){
                vm.seller = response.data;
            }).catch(function(err) {

            });
        }

        function openEditModal(preApprovedItem) {

            $uibModal.open({
                templateUrl: 'templates/physicalfairs/pre-approved/edit/template.modal.html',
                controller: 'EditModalPreApprovedController',
                controllerAs:'vm',
                resolve:
                {
                    preApprovedItem      : function () {
                        return preApprovedItem;
                    },
                    sellers               : function () {
                        return vm.seller;
                    }
                }
            });
        }

        function getByFilter() {
            vm.query = {};

            if(vm.exhibitorName !== '') {
                vm.query['exhibitor_name'] = vm.exhibitorName;
            }

            if(vm.email !== '') {
                vm.query['email'] = vm.email;
            }

            if( vm.activeSelected.name != 'All') {
                vm.query['active']   = vm.activeSelected.value;
            }

            if(typeof vm.sellerSelected !== 'undefined') {
                vm.query['seller']   = vm.sellerSelected.id;
            }

            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo'] = vm.expoSelected.id;
            }

            PhysicalFairService.getByFilterPreApproved(vm.query).then(function(response){
                vm.preApprovedList = response.data;
                vm.queryFlag       = true;
            }).catch(function(err) {

            });
        }



        activate();
    }

})();